import React, { Component } from 'react';
import './appLoader.css'

import AppWindow from '../../images/app-window.svg';
import AlarmBell from '../../images/alarm-bell-sleep-1.svg';
import Rocket from '../../images/space-rocket-flying.svg';

class AppLoader extends Component {

  state = {
    step: 0
  }

  startSequence() {
    this.stepOne = setTimeout(() => {
      this.setState({step: 1})
    }, 345)

    this.stepTwo = setTimeout(() => {
      this.setState({step: 2})
    }, 1535)

    this.stepThree = setTimeout(() => {
      this.setState({step: 3})
    }, 3993)

    this.stepFour = setTimeout(() => {
      this.props.triggerNext()
    }, 6500)

  }

  moveRows() {
    if (this.state.step === 2) {
      return "second"
    } else if (this.state.step === 3) {
      return "third"
    }
  }

  fadeOutFirst() {
    if (this.state.step === 2) {
      return "fade-medium"
    } else if (this.state.step === 3) {
      return "fade-light"
    }
  }

  fadeOutSecond() {

    if (this.state.step === 0) {
      return "fade-medium"
    } else if (this.state.step === 1) {
      return "fade-medium"
    } else if (this.state.step === 3) {
      return "fade-medium"
    }
  }

  fadeOutThird() {

    if (this.state.step === 0) {
      return "fade-light"
    } else if (this.state.step === 1) {
      return "fade-light"
    } else if (this.state.step === 2) {
      return "fade-medium"
    }
  }

  pulseOne() {
    if (this.state.step === 1) {
      return "loader-icon icon-pulse"
    } else if (this.state.step === 0) {
      return "loader-icon icon-pulse"
    } else {
      return "loader-icon"
    }
  }

  pulseTwo() {
    if (this.state.step === 2) {
      return "loader-icon icon-pulse"
    } else {
      return "loader-icon"
    }
  }

  pulseThree() {
    if (this.state.step === 3) {
      return "loader-icon icon-pulse"
    } else {
      return "loader-icon"
    }
  }

  loaderClass() {
    if (this.state.step >= 1) {
      return "loader-bar-finished"
    }
  }


  componentDidMount() {
    this.startSequence()
  }

  componentWillUnmount() {
    clearTimeout(this.stepOne, this.stepTwo, this.stepThree, this.stepFour)
  }

  render() {

    const { initializing, waking, ready } = this.props.copy.appLoader

    return(
      <div className="app-loader-container">
        <div className="app-loader-box">
          <div className={`app-loader-row-container ${this.moveRows()}`}>
            <div className={`app-loader-row  ${this.fadeOutFirst()}`}>
              <img src={AppWindow} alt='' className={`${this.pulseOne()}`}/>
              <h3>{initializing}</h3>
            </div>
            <div className={`app-loader-row  ${this.fadeOutSecond()}`}>
              <img src={AlarmBell} alt='' className={`${this.pulseTwo()}`}/>
              <h3>{waking}</h3>
            </div>
            <div className={`app-loader-row  ${this.fadeOutThird()}`}>
              <img src={Rocket} alt='' className={`${this.pulseThree()}`}/>
              <h3>{ready}</h3>
            </div>
            <div className={`loader-bar-container`}>
              <div className={`loader-bar-start ${this.loaderClass()}`} />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default AppLoader;
